module.exports = __webpack_public_path__ + "img/45_33.8efa76be.png";